import React from "react";
import FormContentWrapper from "Components/FormContentWrapper";
import { useFormData } from "Contexts/FormDataContext";
import { useSession } from "Contexts/SessionContext";
import usePageContextUpdate from "Hooks/usePageContextUpdate";
import MarketingCapabilitiesFormContent from "Components/MarketingCapabilities/MarketingCapabilitiesFormContent";
import MarketingCapabilitiesInfoContent from "Components/MarketingCapabilities/MarketingCapabilitiesInfoContent";
import { marketingCapabilitiesData, getPageNumber } from "Data";

const MarketingCapabilitiesPage = () => {
  const { currentPageData, setSubmitted } = usePageContextUpdate();

  const {
    updateMarketingCapabilities,
    currentFormData: { marketingCapabilities },
  } = useFormData();

  const { updateSession, sessionData } = useSession();

  const calculateScore = (selectedCapabilities) => {
    return selectedCapabilities.reduce((total, capValue) => {
      const capability = marketingCapabilitiesData.find(
        (c) => c.value === capValue,
      );
      return total + (capability?.score || 0);
    }, 0);
  };

  const handleSubmit = async (selectedCapabilities) => {
    const score = calculateScore(selectedCapabilities);

    updateMarketingCapabilities(selectedCapabilities, score);

    await updateSession({
      current_page: getPageNumber("top-goals"),
      q7_score: score,
      responses: {
        ...sessionData?.responses,
        q7_capabilities: {
          capabilities: selectedCapabilities,
          score,
        },
      },
    });

    setSubmitted(true);
  };

  return (
    <FormContentWrapper
      infoContent={
        <MarketingCapabilitiesInfoContent heading={currentPageData.pageTitle} />
      }
      formFieldContent={
        <MarketingCapabilitiesFormContent
          submitCB={handleSubmit}
          defaultCapabilities={marketingCapabilities}
        />
      }
    />
  );
};

export default MarketingCapabilitiesPage;
